import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

export const GroupContainer = styled.fieldset`
  border: 0;
  padding: 0;
  margin-bottom: ${Variables.space150};
`;

export const TagsFilterGroupName = styled.legend`
  display: flex;
  font-weight: bold;
  padding: 0;
  margin-bottom: ${Variables.space75};
`;
